import React, { useEffect } from "react";
import {
  makeStyles,
  Typography,
  Box,
  Grid,
  useMediaQuery,
  Container,
} from "@material-ui/core";

export default function AdvantagePage() {
  const isPhone = useMediaQuery("(max-width:576px)");
  useEffect(() => {
    window.scrollTo({
      top: isPhone ? 0 : 750,
      behavior: "smooth",
    });
  }, [isPhone]);
  return (
    <Box>
      <TitleImg />
      <AdvantageContent />
    </Box>
  );
}

function TitleImg() {
  const isPhone = useMediaQuery("(max-width:576px)");
  const isSmPhone = useMediaQuery("(max-width:576px)");
  // const isTable = useMediaQuery("(max-width:960px)");
  // const isTablet = useMediaQuery("(max-width:1025px)");
  const useStyles = makeStyles((theme) => ({
    img: {
      width: "100%",
      height: isPhone ? "60vh" : "100vh",
      objectFit: "cover",
    },
    textBox: {
      position: "absolute",
      top: "50%",
      left: "50%",
      width: "100%",
      transform: "translate( -50%, -50%)",
      display: "flex",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
  }));
  const classes = useStyles();

  return (
    <Box position="relative">
      <img src="/assets/images/Home/new2.png" className={classes.img} />
      <Container maxWidth="xl">
        <Box className={classes.textBox}>
          <Typography
            variant={isSmPhone ? "body1" : "h5"}
            style={{ color: "#fff", fontWeight: "bold" }}
          >
            FULLHOUSE FORECLOSURE
          </Typography>
          <Typography variant="h6" style={{ color: "#fff" }}>
            經營優勢
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

function AdvantageContent() {
  const isPhone = useMediaQuery("(max-width:576px)");
  const isSmPhone = useMediaQuery("(max-width:576px)");
  const isTable = useMediaQuery("(max-width:960px)");
  const useStyles = makeStyles((theme) => ({
    title: {
      fontWeight: "bold",
      margin: "30px 0px",
      color: theme.palette.primary.main,
      textAlign: "center",
    },
    contentBox: {
      backgroundColor: theme.palette.primary.main,
      borderRadius: "5px",
      margin: "0px 0px 30px 0px",
    },
    contentTitle: {
      margin: "20px 10px",
      color: "#fff",
      textAlign: isPhone ? "left" : "left",
    },
    content: {
      color: "white",
      margin: "0px 20px 25px 20px",
    },
  }));
  const classes = useStyles();

  const contentArray = [
    {
      title: "01•品質第一名：",
      content:
        "専一専營法拍事業,不兼營其業別(例如兼營房屋仲介、代害),専業品質最有保障",
    },
    {
      title: "02•專業第一名：",
      content:
        "法拍的事交給富屋法拍,您將擁有『法政碩士、律師、土地代書、不動經紀人』...等最堅強法拍顧問團隊陣容,標購法拍屋完全沒煩惱",
    },
    {
      title: "03•全國第一本：",
      content:
        "專研不動產相關法令十餘年,全國第一名有能力出法拍、金拍、銀拍屋專業實務系列專書的法拍業者",
    },
    {
      title: "04•評價第一名：",
      content:
        "十餘年來客戶交易零糾紛,富屋秉持誠信專業負責最嚴謹的態度,沒必要開玩笑砸招牌",
    },
    {
      title: "05•合法第一名：",
      content: "堅持合法、和諧之處理原則,以客戶至上,客戶可不必花費搬遷費",
    },
    {
      title: "06•法拍第一名：",
      content:
        "多家『不動產仲介業者』、『代書業者』、『法拍業者』特別指定本公司之系列叢書為教育訓練員工法拍實務專用書",
    },
    {
      title: "07•研究第一名：",
      content:
        "本著永續經營創造多赢為目標,首創『富屋法規研究室』深入研究各項法令繁雜問題,務必使整體效能提高並將繁複程序簡單化,減少不必要的紛爭",
    },
    {
      title: "08•效率第一名：",
      content: "富屋堅持服務品質第一、客戶至上,點交有效率,口碑最良好",
    },
    {
      title: "09•形象第一名：",
      content:
        "富屋企業以【正派經營、誠信服務、光明正氣、專業負責、義中求利】為最高經營指導方針",
    },
    {
      title: "10•團隊第一名：",
      content:
        "經營研究團隊無時無刻深研法拍專業與實務各項繁雜問題,務必將專業品質做到第一",
    },
    {
      title: "11•保障第一名：",
      content: "富屋服務項目分細說,責任點交有保障,客戶可搭配選擇一目了然",
    },
    {
      title: "12•用心第一名：",
      content: "一分錢一分貨,專業品質服務有口皆碑,絕不愉工減料",
    },
    {
      title: "13•誠信第一名：",
      content: "誠實有品質口碑良好,光明正氣不搞欺騙小手段",
    },
    {
      title: "14•資料最完整：",
      content: "投標價格建議有根據有數據資料完整呈現",
    },
    {
      title: "15•經驗最豐富：",
      content: "從事法拍工作十餘年,成功輔助同業得標經驗數千件,經驗非常豐富",
    },
    {
      title: "16•分析最完整：",
      content: "專案分類建檔,積極處理客戶法拍案件,客戶最安心",
    },
    {
      title: "17•收費最合理：",
      content: "服務收費標準表完整提供,不巧立名目,交易完全透明、誠信安全有保障",
    },
    {
      title: "18•理念最明確：",
      content:
        "富屋先生秉持富屋的『精神、文化、傳承』三大原則及『專業、誠信、負責、服務、熱忱』的五大信念為最高經營理念,以其嚴謹專業度誠信服務客戶,讓每一位由富屋先生所服務過的客戶都能從此邁向富貴之屋",
    },
  ];

  return (
    <Box style={{ height: "100%" }}>
      <Grid container justify="center">
        <Grid item xs={11} md={10}>
          <Grid className={classes.titleBox}>
            <Typography
              variant={isPhone ? "h6" : "h4"}
              className={classes.title}
            >
              堅持做到最好、
              <div style={{ display: isSmPhone ? "block" : "none" }}></div>
              堅持做到第一
            </Typography>
          </Grid>
          <Grid>
            {contentArray.map((item) => {
              return (
                <Grid container className={classes.contentBox}>
                  <Grid item xs={12}>
                    <Typography
                      variant={isPhone ? "body1" : "h5"}
                      className={classes.contentTitle}
                    >
                      {item.title}
                    </Typography>
                  </Grid>
                  <Grid item xs={12}>
                    <Typography
                      variant={isPhone ? "body2" : "body1"}
                      className={classes.content}
                    >
                      {item.content}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
}
